import { Link } from "react-router-dom";
import styled from "styled-components";
import { ICON_EMAIL, ICON_FACEBOOK, ICON_INSTAGRAM, ICON_TWITTER } from "../../utils/icons";
import { logo_main } from "../../assets";

const Footer = () => {

      const socials =
            [
                  { icon: ICON_FACEBOOK, link: 'https://www.facebook.com/ReniSuite/' },
                  { icon: ICON_INSTAGRAM, link: 'https://www.instagram.com/ReniSuite' },
                  { icon: ICON_TWITTER, link: 'https://twitter.com/ReniSuite' },
                  { icon: ICON_EMAIL, link: 'mailto:hello@reni.tech' },
            ];

      return (
            <StyledFooter>
                  <footer className="page-footer">
                        <div className="container mb-5 pt-5">
                              <div className="row justify-content-between">

                                    <div className="col-md-4 mx-auto">
                                          <img
                                                src={logo_main}
                                                alt="Reni Fianace"
                                                width="100px"
                                          />

                                          <p className="">
                                                Experience our amazing service with lots of attractive features to be explored.
                                          </p>

                                          <ul className="list-unstyled h5">

                                                <Link to="#"
                                                      className="me-4 h5 fw-bold"
                                                >
                                                      Overview
                                                </Link>

                                                <Link to="#"
                                                      className="me-4 h5 fw-bold"
                                                >
                                                      Features
                                                </Link>

                                                <Link to="#"
                                                      className="me-4 h5 fw-bold"
                                                >
                                                      Pricing
                                                </Link>                                          <Link to="#"
                                                      className="me-4 h5 fw-bold"
                                                >
                                                      Privacy
                                                </Link>


                                          </ul>
                                    </div>
                                    <div className="col-md-4 mx-auto d-none d-md-block">
                                          <h4 className=" text-center mt-5 mb-4 ">
                                                Connect With Us
                                          </h4>
                                          <div className="text-center mb-3">
                                                {
                                                      socials?.map(({ icon, link }, i) =>
                                                            <a
                                                                  key={i}
                                                                  href={link}
                                                                  target="_blank"
                                                                  rel="noreferrer"
                                                                  className='py-3 mx-2 px-2 h4'
                                                            >
                                                                  {icon}
                                                            </a>
                                                      )
                                                }

                                          </div>
                                    </div>
                              </div>

                        </div>

                        <div className="footer-copyright text-center py-3">
                              © 2024{" "}
                              <a href="https://reniaccounts.com" className="sec-bold-text ">
                                    {" "}
                                    reni.finance{" "}
                              </a>{" "}
                              || All rights reserved

                              <hr className="my-1 w-50 mx-auto" />

                              <div style={{ fontSize: "smaller" }}>
                                    Developed by
                                    <a href="https://fireswitch.tech" className="sec-bold-text ">
                                          {" "}
                                          FireSwitch Technologies Ltd{" "}
                                    </a>
                              </div>
                        </div>
                  </footer>
            </StyledFooter >
      );
};

export default Footer;


const StyledFooter = styled.section`
  margin: 0;
  /* padding-top: 2rem; */
  background-color: var(--yellow-color);
  color: var(--light-color);
  background-size: cover;
  width: 100%;
  overflow-x: hidden;

  a{
      color: var(--light-color) !important;
  }

 .connect svg {
  font-size:1.4rem !important;
}

`;